import { template as _$template } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
const _tmpl$ = /*#__PURE__*/_$template(`<div class="fixed flex text-xs font-bold items-center justify-center text-blue-500 bg-blue-500/30">`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class="fixed flex text-xs font-bold items-center justify-center text-orange-500 bg-orange-500/30">`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class="fixed flex text-xs font-bold items-center justify-center text-green-500 bg-green-500/30">`);
export function RenderBoxes(props) {
  return [_$memo(() => Object.entries(props.allBoxes.margin).map(([, box]) => {
    return (() => {
      const _el$2 = _tmpl$2();
      _el$2.style.setProperty("text-shadow", "-1px 1px 0 #fff, 1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff");
      _$effect(_p$ => {
        const _v$5 = box.left + "px",
          _v$6 = box.top + "px",
          _v$7 = box.width + "px",
          _v$8 = box.height + "px";
        _v$5 !== _p$._v$5 && ((_p$._v$5 = _v$5) != null ? _el$2.style.setProperty("left", _v$5) : _el$2.style.removeProperty("left"));
        _v$6 !== _p$._v$6 && ((_p$._v$6 = _v$6) != null ? _el$2.style.setProperty("top", _v$6) : _el$2.style.removeProperty("top"));
        _v$7 !== _p$._v$7 && ((_p$._v$7 = _v$7) != null ? _el$2.style.setProperty("width", _v$7) : _el$2.style.removeProperty("width"));
        _v$8 !== _p$._v$8 && ((_p$._v$8 = _v$8) != null ? _el$2.style.setProperty("height", _v$8) : _el$2.style.removeProperty("height"));
        return _p$;
      }, {
        _v$5: undefined,
        _v$6: undefined,
        _v$7: undefined,
        _v$8: undefined
      });
      return _el$2;
    })();
  })), _$memo(() => Object.entries(props.allBoxes.padding).map(([, box]) => {
    return (() => {
      const _el$3 = _tmpl$3();
      _el$3.style.setProperty("text-shadow", "-1px 1px 0 #fff, 1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff");
      _$effect(_p$ => {
        const _v$9 = box.left + "px",
          _v$10 = box.top + "px",
          _v$11 = box.width + "px",
          _v$12 = box.height + "px";
        _v$9 !== _p$._v$9 && ((_p$._v$9 = _v$9) != null ? _el$3.style.setProperty("left", _v$9) : _el$3.style.removeProperty("left"));
        _v$10 !== _p$._v$10 && ((_p$._v$10 = _v$10) != null ? _el$3.style.setProperty("top", _v$10) : _el$3.style.removeProperty("top"));
        _v$11 !== _p$._v$11 && ((_p$._v$11 = _v$11) != null ? _el$3.style.setProperty("width", _v$11) : _el$3.style.removeProperty("width"));
        _v$12 !== _p$._v$12 && ((_p$._v$12 = _v$12) != null ? _el$3.style.setProperty("height", _v$12) : _el$3.style.removeProperty("height"));
        return _p$;
      }, {
        _v$9: undefined,
        _v$10: undefined,
        _v$11: undefined,
        _v$12: undefined
      });
      return _el$3;
    })();
  })), (() => {
    const _el$ = _tmpl$();
    _el$.style.setProperty("text-shadow", "-1px 1px 0 #fff, 1px 1px 0 #fff, 1px -1px 0 #fff, -1px -1px 0 #fff");
    _$insert(_el$, () => props.allBoxes.innerBox.label);
    _$effect(_p$ => {
      const _v$ = props.allBoxes.innerBox.left + "px",
        _v$2 = props.allBoxes.innerBox.top + "px",
        _v$3 = props.allBoxes.innerBox.width + "px",
        _v$4 = props.allBoxes.innerBox.height + "px";
      _v$ !== _p$._v$ && ((_p$._v$ = _v$) != null ? _el$.style.setProperty("left", _v$) : _el$.style.removeProperty("left"));
      _v$2 !== _p$._v$2 && ((_p$._v$2 = _v$2) != null ? _el$.style.setProperty("top", _v$2) : _el$.style.removeProperty("top"));
      _v$3 !== _p$._v$3 && ((_p$._v$3 = _v$3) != null ? _el$.style.setProperty("width", _v$3) : _el$.style.removeProperty("width"));
      _v$4 !== _p$._v$4 && ((_p$._v$4 = _v$4) != null ? _el$.style.setProperty("height", _v$4) : _el$.style.removeProperty("height"));
      return _p$;
    }, {
      _v$: undefined,
      _v$2: undefined,
      _v$3: undefined,
      _v$4: undefined
    });
    return _el$;
  })()];
}